import List from 'src/storage/list';

class NotificationModel extends List {
  id = 'notification';
  defaultState = () => ({ current: 'recent' });
  refreshOnInit = false;
  refreshOnSubscribe = true;
  persistent = false;
  sortBy = {
    key: 'id',
    desc: true
  };
  apiConfig = {
    refresh: {
      url: 'notification/refresh',
      validation: {
        skip: 'skip',
        limit: 'limit'
      },
      cancellable: true,
      event: 'notification_list'
    },
    list: {
      url: 'notification/list',
      validation: {
        skip: 'skip',
        limit: 'limit'
      },
      cancellable: true,
      event: 'notification_list'
    },
    clear_all: {
      url: 'notification/clear'
    }
  };
  _events = {
    notification_list: 'onNotificationList',
    'foxsocket:message:notification': 'handleNotification',
    'foxsocket:message:user_update': 'handleUpdateUserWS'
  };

  onNotificationList = () => {
    const id = this.getCurrentId() === 'search' ? 'search' : 'refresh';
    this.setState({
      total: this.requests[id]?.response?.total || 0
    });
  };

  clearAll = () => {
    this.api('clear_all', {}, () => {
      this.setStateSilent({ total: 0 });
      this.setListState({ items: [] });
    });
  };

  mapItem = (item, index, items) => {
    if (typeof item.category === 'undefined') {
      if (index === 0) {
        item.category = item.unread ? 'New' : 'Earlier';
      } else {
        if (
          items[index - 1].unread === true &&
          item.unread === false &&
          index % this.listLimit != 0
        ) {
          item.category = 'Eearlier';
        } else {
          item.category = '';
        }
      }
    }
    return item;
  };

  handleNotification = ({ channel, data }) => {
    this.log('handleNotification', data);
    let userId = this.userId;

    if (userId === data.nUserId) return;
    if (channel !== 'u-' + userId) return;
    let items = this.items();
    var exist = false;
    for (var i = 0; i < items.length; i++) {
      if (items[i].id === data.id) {
        items[i] = this.mapItem(data, i, items);
        exist = true;
        this.log('updated');
        this.trigger();
        break;
      } else {
        this.log(items[i].id, data.id);
      }
    }
    if (!exist) {
      this.log('notification not found, adding', data);
      items.unshift(this.mapItem(data, 0, items));
      if (items[1] && items[1].category === 'New') items[1].category = '';
      this.setListState({ items });
    }
  };

  handleUpdateUserWS = ({ data }) => {
    let { userId, key, value } = data;
    let items = this.items();
    items.map((item) => {
      if (item.nUserId === userId) item[key] = value;
    });
    this.setListState({ items });
  };
}

const model = new NotificationModel();
export default model;
